import React from "react";

// Assets
import "~/assets/sass/pages/mypage/admin/connect.scss";

import { ConnectIcon } from "~/assets/svg/MathIcon";
import logoSquare from "~/assets/img/logo-vc.png";

const CompanyList = ({ setSampleModal, confirmList, setDisconnectTarget }) => {
	return (
		<>
			<div className="c__card">
				<div className="connect-table startup">
					<ul className="table-head">
						<li className="connect-num">No</li>
						<li className="connect-name">기업</li>
						<li className="connect-check" />
						<li className="connect-date">날짜</li>
						<li className="connect-active">상태</li>
					</ul>

					{confirmList === [] ? (
						confirmList.map((cf, index) => (
							<ul>
								<li className="connect-num" key={index}>
									{index + 1}
								</li>
								<li className="connect-name">
									<div className="connect-startup">
										<div className="connect-startup-logo">
											<img src={logoSquare} alt="기업샘플" />
										</div>
										<dl>
											<dt className="connect-startup-name">(주)일루넥스</dt>
											<div className="connect-startup-info">
												<dd>서울</dd>
												<dd>4년</dd>
												<dd>응용소프트웨어 개발 및 공급업</dd>
											</div>
										</dl>
									</div>
								</li>
								<li className="connect-check">
									<ConnectIcon />
								</li>
								<li className="connect-date">2020-11-20 17:43</li>
								<li className="connect-active">
									<button
										type="button"
										className="btn__solid"
										color="primary"
										onClick={() => {
											// 아래 1은 임시 숫자
											setDisconnectTarget(1);
											setSampleModal(true);
										}}
									>
										연결취소
									</button>
								</li>
							</ul>
						))
					) : (
						<div className="no-content">현재 연결을 요청한 기업이 없습니다.</div>
					)}

					{/* 연결중 */}
					{/* <ul>
						<li className="connect-num">01</li>
						<li className="connect-name">
							<div className="connect-startup">
								<div className="connect-startup-logo">
									<img src={logoSquare} alt="기업샘플" />
								</div>
								<dl>
									<dt className="connect-startup-name">(주)일루넥스</dt>
									<div className="connect-startup-info">
										<dd>서울</dd>
										<dd>4년</dd>
										<dd>응용소프트웨어 개발 및 공급업</dd>
									</div>
								</dl>
							</div>
						</li>
						<li className="connect-check">
							<ConnectIcon />
						</li>
						<li className="connect-date">2020-11-20 17:43</li>
						<li className="connect-active">
							<button
								type="button"
								className="btn__solid"
								color="primary"
								onClick={() => {
									setDisconnectTarget("1")
									setSampleModal(true)
								}}
							>
								연결취소
							</button>
						</li>
					</ul> */}

					{/* 대기중 */}
					{/* <ul>
						<li className="connect-num">01</li>
						<li className="connect-name">
							<div className="connect-startup">
								<div className="connect-startup-logo">
									<img src={logoSquare} alt="기업샘플" />
								</div>
								<dl>
									<dt className="connect-startup-name">(주)일루넥스</dt>
									<div className="connect-startup-info">
										<dd>서울</dd>
										<dd>4년</dd>
										<dd>응용소프트웨어 개발 및 공급업</dd>
									</div>
								</dl>
							</div>
						</li>
						<li className="connect-check"/>
						<li className="connect-date">2020-11-20 17:43</li>
						<li className="connect-active">
							<button type="button" className="btn__solid connecting" color="gray">
								대기중
							</button>
						</li>
					</ul> */}

					{/*내용없을때*/}
					{/*<div className="no-content">현재 연결을 요청한 기업이 없습니다.</div>*/}
				</div>
			</div>
		</>
	);
};

export default CompanyList;
